<template>
  <section>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <HeaderSmall :pageTitle="pageData.title" />
    <div class="container">
    <section class="section m-y-xl">
      <div class="columns">
        <div class="column">

          <div class="content">
            <div v-html="$marked(pageData.content)"></div>
          </div>

        <vue-friendly-iframe className="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2734.253337585566!2d29.696902391434588!3d46.74018679699499!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6d7fbcfbd1dcbc48!2z0KbQtdGA0LrQvtCy0YwgIiDQldCl0JEi!5e0!3m2!1sen!2s!4v1594589365061!5m2!1sen!2s"></vue-friendly-iframe>

        </div>
        <div class="column">

      <section class="box">
          <div v-if="form.visible">
            <b-field
              :label="trans[lang].form.name"
              :type="form.name.status"
              :message="form.name.message"
            >
              <b-input
                v-model="form.name.data"
                :placeholder="trans[lang].form.nameHolder"
                required
              ></b-input>
            </b-field>
            <b-field
              :label="trans[lang].form.email"
              :type="form.email.status"
              :message="form.email.message"
            >
              <b-input
                type="email"
                v-model="form.email.data"
                :placeholder="trans[lang].form.emailHolder"
                required
              ></b-input>
            </b-field>
            <b-field
              :label="trans[lang].form.phone"
              :type="form.phone.status"
              :message="form.phone.message"
            >
              <b-input
                v-model="form.phone.data"
                :placeholder="trans[lang].form.phoneHolder"
                required
              ></b-input>
            </b-field>
            <b-field
              :label="trans[lang].form.message"
              :type="form.text.status"
              :message="form.text.message"
              expanded
            >
              <b-input
                maxlength="500"
                type="textarea"
                v-model="form.text.data"
                :placeholder="trans[lang].form.messageHolder"
              ></b-input>
            </b-field>
          <b-field
            class="m-t-md"
            v-if="form.visible"
            :label="form.human.label"
            :type="form.human.status"
            :message="form.human.message"
            horizontal
          >
            <b-input
              type="text"
              v-model="form.human.data"
              :placeholder="trans[lang].form.humanHolder"
              required
            ></b-input>
          </b-field>
          </div>

          <div class="content">
            <b-message :type="form.status" v-if="form.result">
              {{ form.message }}
            </b-message>
          </div>
<div class="has-text-right">
          <button
            v-if="form.visible"
            class="button is-primary"
            @click="sendMessage()"
          >
            {{trans[lang].form.send}}
          </button>
          <button
            v-if="!form.visible"
            class="button is-success"
            @click="resetForm()"
          >
            {{trans[lang].form.reset}}
          </button>
</div>

        </section>

        </div>
      </div>
    </section>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import HeaderSmall from "@/components/HeaderSmall.vue";
export default {
  name: "Contacts",
  components: {
    HeaderSmall
  },
  data() {
    return {
      isLoading: false,
      trans:{
        en:{
          form:{
            name: "Name",
            nameHolder: "Your Name",
            email: "Email",
            emailHolder: "Your Email",
            phone: "Phone",
            phoneHolder: "Your Phone",
            message: "Message",
            messageHolder: "Your Message",
            humanHolder: "Your answer",
            errorField: "Please fill out this field.",
            errorEmail: "Please enter a valid email address.",
            errorHuman: "You did not pass the human test.",
            errorSend: "Ooops! Something went wrong. Please try again.",
            noErrors: "Looks Good",
            done:"Message Sent.",
            send: "Send",
            reset: "Send Another"
          },
          title: "Contacts",
          description: "MD5702, Moldova, Slobozia district, Slobozia, 33 Sovetskaya St."
        },
        ru:{
          form:{
            name: "Имя",
            nameHolder: "Ваше Имя",
            email: "Email",
            emailHolder: "Ваша почтовый ящик",
            phone: "Телефон",
            phoneHolder: "Ваш Телефон",
            message: "Сообщение",
            messageHolder: "Ваше Сообщение",
            humanHolder: "Ваш ответ",
            errorField: "Заполните поле",
            errorEmail: "Введите верный адрес электронной почты",
            errorHuman: "Вы ответили неверно на проверочный вопрос",
            errorSend: "Не удалось отправить сообщение. Попробуйте еще раз.",
            noErrors: "Отлично",
            done: "Ваше сообщение успешно отправлено",
            send: "Отправить",
            reset: "Новое Сообщение"
          },
          title: "Контакты",
          description: "MD5702, Moldova, Слободзейский район, г.Слободзея, ул.Советская-33"
        }
      },
      pageData: {
        content:""
      },
      token: null,
      form: {
        email: {
          data: "",
          status: null,
          message: null
        },
        name: {
          data: "",
          status: null,
          message: null
        },
        phone: {
          data: "",
          status: null,
          message: null
        },
        text: {
          data: "",
          status: null,
          message: null
        },
        human: {
          lable:"",
          summ: null,
          data: null,
          status: "",
          message: ""
        },
        visible: true,
        message: null,
        result: false,
        status: null
      },
      hasMeta: {
        title: "",
        description: ""
      }
    };
  },
  methods:{
    loadPageData() {
      let getFrom = this.lang+"-contact";
      this.isLoading = true;
      this.axios
        .get(getFrom)
        .then(response => {
          this.isLoading = false;
          if (response.data.id) {
            this.pageData = response.data;
          } else {
            console.log("Error getting data");
          }
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error);
        });
      //.finally(() => (this.loading = false));
    },
    getToken() {
      this.axios
        .post("https://sloboziabc.org/api/gentocken.php",{
            action: "gen",
        })
        .then(response => {
          if (response.data.success) {
            this.token = response.data.jwt;
            console.log("Token Generated:" + this.token);
          } else {
            console.log("Error generating token");
          }
        })
        .catch(error => {

          console.log(error);
        });
      //.finally(() => (this.loading = false));
    },
    generateCapcha(){
      let var0 = Math.floor(Math.random() * 9) + 1;
      let var1 = Math.floor(Math.random() * 9) + 1;
      this.form.human.summ = var0 + var1;
      this.form.human.label =  var0 + '+' + var1 + '=';
    },
    sendMessage() {
      if (
        this.emailCheck("email") &
        this.formCheck("name") &
        this.formCheck("phone") &
        this.formCheck("text") &
        this.humanCheck("human")
      ) {
        this.isLoading = true;
        this.axios
        .post("https://sloboziabc.org/api/sendmail.php",{
            action: "message",
            token: this.token,
            email: this.form.email.data,
            name: this.form.name.data,
            phone: this.form.name.phone,
            message: this.form.text.data
        })
        .then(response => {
          this.isLoading = false;
          console.log(response.data);
          if (response.data.success) {
            this.form.visible = false;
            this.form.status = "is-success";
            this.form.result = true;
            this.form.message = this.trans[this.lang].form.done;
          } else {
            console.log("Error getting data");
            this.form.result = true;
            this.form.message = this.trans[this.lang].form.errorSend;
          }
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error);
        });
      //.finally(() => (this.loading = false));
      } else {
        this.form.status = "is-danger";
        this.form.result = true;
        this.form.message = this.trans[this.lang].form.errorSend;
      }
    },
    emailCheck(e) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
      if (!this.form[e].data || !re.test(this.form[e].data)) {
        this.form[e].status = "is-danger";
        this.form[e].message = this.trans[this.lang].form.errorEmail;
        return false;
      } else {
        this.form[e].message = null;
        this.form[e].status = "is-success";
        this.form[e].message = this.trans[this.lang].form.noErrors;
        return true;
      }
    },
    formCheck(e) {
      if (!this.form[e].data) {
        this.form[e].status = "is-danger";
        this.form[e].message = this.trans[this.lang].form.errorField;
        return false;
      } else {
        this.form[e].status = "is-success";
        this.form[e].message = this.trans[this.lang].form.noErrors;
        return true;
      }
    },
    humanCheck() {
      if (this.form.human.data == this.form.human.summ) {
        this.form.human.status = "is-success";
        this.form.human.message = this.trans[this.lang].form.noErrors;
        return true;
      } else {
        this.form.human.status = "is-danger";
        this.form.human.message = this.trans[this.lang].form.errorHuman;
        return false;
      }
    },
    resetForm() {
      this.form.visible = true;
      this.form.status = "is-success";
      this.form.result = false;
      this.form.message = "";
      this.form.name.data = "";
      this.form.email.data = "";
      this.form.phone.data = "";
      this.form.text.data = "";
      this.generateCapcha();
    },
    doMeta(){
      if(this.lang){
        this.hasMeta.title = this.trans[this.lang].title;
        this.hasMeta.description = this.trans[this.lang].description;
      }
    }
  },
  mounted() {
    this.loadPageData();
    this.generateCapcha();
    this.getToken();
    this.doMeta();

  },
  computed: {
    ...mapState(["lang"]),
  },
  watch:{
    lang: function () {
      this.loadPageData();
      this.generateCapcha();
      this.doMeta();
    }
  },
   metaInfo() {
    return {
      title: this.$mySite.title,
      titleTemplate: this.hasMeta.title + " | %s",
      htmlAttrs: {
        lang: this.lang
      },
      meta: [
        {
          name: "description",
          content: this.hasMeta.description
        },
        {
          property: "og:title",
          content: this.$mySite.title,
          vmid: "og:title"
        },
        {
          property: "og:description",
          content: this.hasMeta.description,
          vmid: "og:description"
        },
        {
          property: "og:image",
          content: this.$mySite.image,
          vmid: "og:image"
        },
        {
          property: "og:url",
          content: this.$mySite.url,
          vmid: "og:url"
        }
      ]
    };
  } //end meta
}
</script>
<style>
.map{
  width: 100%!important;
  height: 300px!important;
  overflow: hidden;
  display: block;
  border: none;
}
</style>


